import React, { Component } from 'react';

class CategoryIcons extends Component{
    constructor(props){
        super(props);

        this.state = {
            black: true,
        }
    }

    changeColor(){
        this.setState({black: !this.state.black})
    }


    render(){
        const p = this.props;

        switch(p.type){
            // ====== NON-SOLIDS CONTAINING CANNABIS value = 70
            case "non-solids containing cannabis":
                return(
                    <span className="category_icon">
                        <p className={p.colorIcon ? p.colorIcon && "icon-techpos-non-solids-ca" : "icon-techpos-non-solids-ca"}></p>
                        {p.categoryName && 
                            <span className={p.titleClass}>{p.categoryName.charAt(0).toUpperCase() + p.categoryName.slice(1)}</span>
                        }
                    </span>
                );
            // ====== SOLIDS CONTAINING CANNABIS value = 15
            case "solids containing cannabis":
                return(
                    <span className={"category_icon"}>
                        <p className={p.colorIcon ? p.colorIcon && "icon-techpos-solids-ca" : "icon-techpos-solids-ca"}></p>
                        {p.categoryName && 
                            <span className={p.titleClass}>{p.categoryName.charAt(0).toUpperCase() + p.categoryName.slice(1)}</span>
                        }
                    </span>
                );
            // ====== FRESH CANNABIS value = 5
            case "fresh cannabis":
                return(
                    <span className="category_icon">
                        <p className={p.colorIcon ? p.colorIcon && "icon-techpos-fresh" : "icon-techpos-fresh"} ></p>
                        {p.categoryName && 
                            <span className={p.titleClass}>{p.categoryName.charAt(0).toUpperCase() + p.categoryName.slice(1)}</span>
                        }
                    </span>
                );
            // ====== DRIED CANNABIS value = 1
            case "dried cannabis":
                return(
                    <span className="category_icon">
                        <p className={p.colorIcon ? p.colorIcon && "icon-techpos-dried" : "icon-techpos-dried"}></p>
                        {p.categoryName && 
                            <span className={p.titleClass}>{p.categoryName.charAt(0).toUpperCase() + p.categoryName.slice(1)}</span>
                        }
                    </span>
                );
            // ====== SOLID CONCENTRATES value = 0.25
            case "cannabis solid concentrates":
                return(
                    <span className="category_icon">
                        <p className={p.colorIcon ? p.colorIcon && "icon-techpos-solids-con" : "icon-techpos-solids-con"}></p>
                        {p.categoryName && 
                            <span className={p.titleClass}>{p.categoryName.charAt(0).toUpperCase() + p.categoryName.slice(1)}</span>
                        }
                    </span>
                );
            // ====== NON-SOLID CONCENTRATES value = 0.25
            case "cannabis non-solid concentrates":
                return(
                    <span className="category_icon">
                        <p className={p.colorIcon ? p.colorIcon && "icon-techpos-non-solids-con" : "icon-techpos-non-solids-con"}></p>
                        {p.categoryName && 
                            <span className={p.titleClass}>{p.categoryName.charAt(0).toUpperCase() + p.categoryName.slice(1)}</span>
                        }
                    </span>
                );
            // ====== PLANT SEEDS value = 1
            case "cannabis plant seeds":
                return(
                    <span className="category_icon">
                        <p className={p.colorIcon ? p.colorIcon && "icon-techpos-seeds" : "icon-techpos-seeds"}></p>
                        {p.categoryName && 
                            <span className={p.titleClass}>{p.categoryName.charAt(0).toUpperCase() + p.categoryName.slice(1)}</span>
                        }
                    </span>
                );
            default:
                return(
                    <span className="category_icon">
                        <p className={p.colorIcon ? p.colorIcon && "icon-techpos-uncategorized" : "icon-techpos-uncategorized"}></p>
                        {p.categoryName && 
                            <span className={p.titleClass}>{p.categoryName.charAt(0).toUpperCase() + p.categoryName.slice(1)}</span> 
                        }
                    </span>
                );
        }
    }
}

export default CategoryIcons;